<template>
    <div >
        <v-row class="no-frame pl-0 pr-1">
            <v-col class="no-frame col-9 incident-title primary--text">
                <a @click="onIncident">
                    <v-icon style="margin-left: -5px" color="primary" size="20">mdi-menu-right</v-icon>
                    <span style="margin-left: -7px"> {{ incident.id }} {{ incident.type.name }}</span>
                </a>
            </v-col>
            <v-col class="no-frame text-right col-3">
            </v-col>
        </v-row>
        <v-row
            class="no-frame lm-border pa-3 "
            v-for="(step, index) in incident.steps"
            :key = "index"
            :class = "index < incident.steps.length-1 ? 'mb-3' : ''"
        >
            <inc-warranty-step
                :step="step"
                :selected="selected"
            />
        </v-row>
    </div>
</template>

<script>

import Inc from "@/modules/inc/service/Inc";
import IncWarrantyStep from "@/modules/inc/warranty/IncWarrantyStep.vue";
export default {
    name: "IncWarrantyIncident",
    components: {
        IncWarrantyStep
    },

    props: {
        incident: {

        },

        selected: {

        }
    },

    methods: {
        onIncident () {
            this.$emit("close");
            Inc.goto(this, this. incident.id)
        }
    }
}
</script>

<style scoped>

.incident-title {
    font-size: 15px!important;
    font-weight: 400;
}

</style>